import { FAQPage, Question, WithContext } from 'schema-dts';
import { Faq, Product } from 'src/types';

export function faqPage(product: Product): WithContext<FAQPage> | null {
  if (!product?.faqs) return null;

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity:
      product.faqs.filter(Boolean).map(f => faqSchema(f as Faq)) || [],
  };
}

export function faqSchema(faq: Faq): Question {
  return {
    '@type': 'Question',
    name: faq.question!,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer!,
    },
  };
}
